export default (text) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  let range = document.createRange()
  range.selectNode(textArea)
  window.getSelection().addRange(range)
  textArea.focus()
  textArea.select()
  try {
    let successful = document.execCommand('copy')
    let msg = successful ? 'successful' : 'unsuccessful'
  } catch (err) {}
  window.getSelection().removeAllRanges()
  document.body.removeChild(textArea)
}
